import { useState } from "react"
import axiosInstance from "../../../../services/axios-client"
import { toast } from "react-toastify"
import { handleApiErrorWithLogs } from "../../../../utils/errorHandler"

const useActualScore = () => {
    const [file, setSelectedFile] = useState(null)
    const [logs, setLogs] = useState(null)
    const [loadingPagestate, setLoadingPage] = useState(false)
    const [fileInputKey, setFileInputKey] = useState(Date.now())

    const handleFileChange = (event) => {
        const file = event.target.files[0]
        setSelectedFile(file)
        setLogs(null) // Clear previous logs
    }

    const clearFileInput = () => {
        setSelectedFile(null)
        setFileInputKey(Date.now()) // Force re-render of input element
    }

    const postActualScore = async (projectID, onSuccess) => {
        try {
            setLoadingPage(true)
            const formData = new FormData()
            formData.append("projectID", projectID)
            formData.append("excelFile", file)

            await axiosInstance.post('/auth/actual-scores/upload', formData)
            toast.success("Success Add Actual Score")
            clearFileInput()
            if (onSuccess) {
                onSuccess()
            }
        } catch (error) {
            handleApiErrorWithLogs(error, setLogs)
        } finally {
            setLoadingPage(false)
        }
    }

    return {
        file,
        fileInputKey,
        handleFileChange,
        postActualScore,
        logs,
        loadingPagestate
    }
}

export default useActualScore